import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase/config";
import { signInWithEmailAndPassword } from "firebase/auth";
import Header from "../components/Header";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await signInWithEmailAndPassword(auth, form.email, form.password);
      navigate("/admin/panel");
    } catch (err) {
      setError("Invalid credentials. Please check your email and password.");
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <Header subtitle="Admin" />
      <div style={{ maxWidth: 420, margin: "80px auto", padding: "0 20px" }}>
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <div style={{ width: 60, height: 60, borderRadius: 16, background: "linear-gradient(135deg,var(--accent2),var(--accent))", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.5rem", margin: "0 auto 16px" }}>🔐</div>
          <h1 style={{ fontFamily: "'Poppins',sans-serif", fontWeight: 800, fontSize: "1.6rem", marginBottom: 8 }}>Admin Login</h1>
          <p style={{ color: "var(--muted)", fontSize: "0.88rem" }}>Authorized personnel only</p>
        </div>
        <div className="glass-card">
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label className="form-label">Admin Email</label>
              <input className="form-input" type="email" placeholder="admin@hyperdigitech.com" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input className="form-input" type="password" placeholder="Enter admin password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />
            </div>
            {error && <div style={{ padding: "10px 14px", background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.2)", borderRadius: 10, color: "var(--danger)", fontSize: "0.82rem", marginBottom: 16 }}>{error}</div>}
            <button className="btn-primary" type="submit" disabled={loading}>{loading ? "Signing in..." : "Sign In to Admin Panel"}</button>
          </form>
        </div>
        <p style={{ textAlign: "center", marginTop: 20, fontSize: "0.78rem", color: "var(--muted)" }}>
          <a href="/" style={{ color: "var(--accent)", textDecoration: "none" }}>← Back to Student Portal</a>
        </p>
      </div>
    </div>
  );
}